import { LocationWithAssetCount } from '../../types';

export const bgRadialGradient = `radial-gradient(at 92% 6%, hsla(300,26%,17%,1) 0px, transparent 50%),
radial-gradient(at 17% 23%, hsla(265,83%,23%,1) 0px, transparent 50%),
radial-gradient(at 70% 12%, hsla(297,60%,22%,1) 0px, transparent 50%),
radial-gradient(at 16% 83%, hsla(264,87%,22%,1) 0px, transparent 50%),
radial-gradient(at 84% 93%, hsla(240,85%,21%,1) 0px, transparent 50%),
radial-gradient(at 34% 61%, hsla(266,80%,30%,1) 0px, transparent 50%),
radial-gradient(at 54% 43%, hsla(265,78%,50%,1) 0px, transparent 50%),
radial-gradient(at 44% 12%, hsla(300,100%,86%,1) 0px, transparent 50%)`;

export const generateFakeDomesticLocations: (
  totalAssetCount: number,
) => LocationWithAssetCount[] = (totalAssetCount) =>
  [
    // North Scotland
    {
      latitude: 56.827657,
      longitude: -4.16329,
      proportion: 0.04,
    },
    // South Scotland
    {
      latitude: 55.50612,
      longitude: -3.665487,
      proportion: 0.05,
    },
    // North East
    {
      latitude: 54.98047,
      longitude: -1.746298,
      proportion: 0.08,
    },
    // North West
    {
      latitude: 54.336165,
      longitude: -2.78454,
      proportion: 0.1,
    },
    // Yorkshire
    {
      latitude: 53.563943,
      longitude: -1.192663,
      proportion: 0.09,
    },
    // North Wales
    {
      latitude: 52.87988,
      longitude: -3.378942,
      proportion: 0.06,
    },
    // South Wales
    {
      latitude: 51.960321,
      longitude: -3.546483,
      proportion: 0.07,
    },
    // East Midlands
    {
      latitude: 52.902251,
      longitude: -0.646093,
      proportion: 0.09,
    },
    // West Midlands
    {
      latitude: 52.290818,
      longitude: -2.228124,
      proportion: 0.092,
    },
    // East Anglia
    {
      latitude: 52.129248,
      longitude: 0.155909,
      proportion: 0.046,
    },
    // London
    {
      latitude: 51.504202,
      longitude: -0.01646,
      proportion: 0.11,
    },
    // South East
    {
      latitude: 50.985275,
      longitude: 0.586222,
      proportion: 0.087,
    },
    // South
    {
      latitude: 51.056111,
      longitude: -1.578085,
      proportion: 0.054,
    },
    // South West
    {
      latitude: 50.685189,
      longitude: -3.942892,
      proportion: 0.04,
    },
  ].map(({ proportion, ...location }) => ({
    ...location,
    count: Math.round(totalAssetCount * proportion),
    type: 'Fake',
  }));

export const CONTRACTED_MW = 6000;
